var module = angular.module('octopusApp.shared');

module.directive('octoForm', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      form: '=',
      submitted: '=',
      isSubmitting: '=',
      isFormDisabled: '='
    },
    templateUrl: 'areas/shared/views/octo-form.html',
    link: function (scope, element, attrs) {
      scope.formElements = [];

      scope.$watch('form', function () {
        scope.formElements = [];

        if (!scope.form || !scope.form.Elements) {
          return;
        }

        _.each(scope.form.Elements, function(element) {
          scope.formElements.push({
            label: element.Name,
            name: element.Name,
            type: element.Control.Type,
            required: element.IsValueRequired,
            properties: element.Control,
            value: scope.form.Values[element.Name]
          });
        });
      });

      scope.$on("interruptionField:changed", function () {
        var result = {};
        _.each(scope.formElements, function (el) {
          result[el.name] = el.value;
          if (!result[el.name]) {
            result[el.name] = '';
          }
        });

        scope.form.Values = result;
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/octo-form.js
// module id = 596
// module chunks = 1